export default __webpack_public_path__ + "static/media/octahedron.d1532de4.png";